import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {AuthenticationService} from "../../../sec/services/auth.service";
import {Router} from "@angular/router";
import {Usuario} from "../../../model/usuario";

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  usuarioLogueado: Usuario;


  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private router: Router,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authenticationService:AuthenticationService) {
  }


  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.usuarioLogueado = this.authenticationService.getCurrentUser();

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    //this.menuService.navigateHome();
    this.router.navigate(['/landing']);
    return false;
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['auth/login']);
  }

  abrirComponenteVistaTurnos() {
    // Obtener la URL absoluta del destino
    const url = this.router.serializeUrl(
        this.router.createUrlTree(['/public/gln'])
    );
    const fullUrl = window.location.pathname +
        '#'+
        url;

    // Abrir en nueva pestaña
    window.open(fullUrl, '_blank');
  }
  abrirManual() {
    // Obtener la URL absoluta del destino
    const url = this.router.serializeUrl(
        this.router.createUrlTree(['/manual'])
    );
    const fullUrl = window.location.pathname +
        '#'+
        url;

    // Abrir en nueva pestaña
    window.open(fullUrl, '_blank');
  }

  esLocalOAdmin() {
    if (localStorage.getItem("currentUser")!=null &&
        JSON.parse(localStorage.getItem("currentUser")).perfil &&
        (JSON.parse(localStorage.getItem("currentUser")).perfil =='LOCAL'
        || JSON.parse(localStorage.getItem("currentUser")).perfil =='ADMIN')
    ) {
      return true;

    }
    return false;
  }
}
